export default [
  {
    path: "/index",
    name: "index",
    meta: {
      title: "首页",
      footer: true,
      backgroundColor: "#fff"
    },
    component: () => import("@views/home/Index")
  },
  {
    path: "/exam/index",
    name: "exam-index",
    meta: {
      title: "我的练习",
      auth: true,
      backgroundColor: "#fff"
    },
    component: () => import("@views/exam/Index")
  },
  {
    path: "/exam/lib/view/:id",
    name: "lib-index",
    meta: {

      title: "我的练习题",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/LibIndex")
  },
  {
    path: "/exam/practice/order/view/:id",
    name: "lib-order",
    meta: {
      title: "顺序练习",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeOrderView")
  },
  {
    path: "/exam/practice/chapter/view/:id",
    name: "lib-chapter",
    meta: {
      title: "章节练习",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeChapterStart")
  },
  {
    path: "/exam/practice/imitate/view/:id",
    name: "lib-imitate",
    meta: {
      title: "模拟考试",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeImitateStart")
  },
  {
    path: "/exam/practice/order/result/:id",
    name: "lib-result",
    meta: {
      title: "练习情况",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeOrderResult")
  },
  {
    path: "/exam/practice/order/start/:id",
    name: "lib-start",
    meta: {
      title: "答题中...",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeOrderStart")
  },
  {
    path: "/exam/practice/wrong/view/:id",
    name: "lib-wrong",
    meta: {
      title: "我的错题",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeOrderWrong")
  },
  {
    path: "/exam/practice/store/view/:id",
    name: "lib-store",
    meta: {
      title: "我的收藏",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeOrderStore")
  },
  {
    path: "/exam/practice/day/start/:id",
    name: "day-practice",
    meta: {
      title: "每日一练",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeDayStart")
  },
  {
    path: "/exam/practice/day/result/:id",
    name: "day-finish",
    meta: {
      title: "恭喜完成答题",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeDayResult")
  },
  {
    path: "/exam/practice/day/analysis/:id",
    name: "day-analysis",
    meta: {
      title: "全部解析",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeDayAnalysis")
  },
  {
    path: "/exam/practice/day/wrong/:id",
    name: "day-wrong",
    meta: {
      title: "错题解析",
      auth: true,
      backgroundColor: "#fff",
    },
    component: () => import("@views/exam/PracticeDayWrong")
  },
];
